export const cardsConvertingActions = {
  UPDATE_CARDS_CONVERTING_TEMPLATE: 'UPDATE_CARDS_CONVERTING_TEMPLATE',
}